import * as yup from 'yup'
import { defineMessages } from 'react-intl'

const nameMessages = defineMessages({
  required: {
    id: 'items.form.name.required',
    defaultMessage: 'The name is required'
  },
  max: {
    id: 'items.form.name.max',
    defaultMessage: 'The name can be up to 40 characters'
  }
})

const brandMessages = defineMessages({
  required: {
    id: 'items.form.brand.required',
    defaultMessage: 'The brand is required'
  }
})

const photoMessages = defineMessages({
  required: {
    id: 'items.form.photo.required',
    defaultMessage: 'The photo is required'
  },
  max: {
    id: 'items.form.photo.max',
    defaultMessage: 'The photo is required'
  }
})

const netContentMessages = defineMessages({
  required: {
    id: 'items.form.netContent.required',
    defaultMessage: 'The net content is required'
  }
})

const unitsMessages = defineMessages({
  required: {
    id: 'items.form.units.required',
    defaultMessage: 'The units is required'
  }
})

const categoryMessages = defineMessages({
  required: {
    id: 'items.form.category.required',
    defaultMessage: 'The category is required'
  }
})

const subcategoryMessages = defineMessages({
  required: {
    id: 'items.form.subcategory.required',
    defaultMessage: 'The subcategory is required'
  }
})

const containerMessages = defineMessages({
  required: {
    id: 'items.form.container.required',
    defaultMessage: 'The container is required'
  }
})

const sellingPriceMessages = defineMessages({
  required: {
    id: 'items.form.sellingPrice.required',
    defaultMessage: 'The price is required'
  }
})

export const schema = (intl: TSFixMe): TSFixMe => {
  return yup.object().shape({
    name: yup
      .string()
      .required(intl.formatMessage(nameMessages.required))
      .max(40, intl.formatMessage(nameMessages.max)),
    photo: yup.string().required(intl.formatMessage(photoMessages.required)),
    brand: yup.string().required(intl.formatMessage(brandMessages.required)),
    netContent: yup.string().required(intl.formatMessage(netContentMessages.required)),
    units: yup.string().required(intl.formatMessage(unitsMessages.required)),
    category: yup.string().required(intl.formatMessage(categoryMessages.required)),
    subcategory: yup.string().required(intl.formatMessage(subcategoryMessages.required)),
    container: yup.string().required(intl.formatMessage(containerMessages.required)),
    sellingPrice: yup.string().required(intl.formatMessage(sellingPriceMessages.required))
  })
}
